<template>
    <div class="backdrop" @click.self="onClose">
        <div class="report-modal">
            <div>
                <RangeSelector @on-view="onView" @on-close="onClose" />
            </div>
            <div style="display:flex; flex-direction: columns;justify-content:space-between;background-color: var(--con-main-theme-card-header-color-2);">
                <div class="report-title">{{ reportTitle }}</div>
                <div style="display:flex; flex-direction: columns;justify-content:flex-end;background-color: #2196e2;" v-show="dataReport != null">
                    <div class="report-export" @click="savePdf">PDF</div>
                    <div class="report-export" @click="exportCsv">CSV</div>
                </div>
            </div>
            <div style="background: white; overflow-y: auto;height: 90%;" v-show="dataReport != null">
                <div style="display:flex; flex-direction: columns;justify-content:flex-end;background-color: #eeffee; color:black;padding: 0px; border: 1px solid black; margin-bottom: 0px;">
                    <span style="margin: 10px;margin-right: 10px;" v-if="portalUser.isAdmin || portalUser.isAdminPlus">
                        <a class="button-link" @click="toggleLineItemConfig"> {{ configLineItemMode ? "Save Show/Hide" : "Edit Show/Hide" }}</a>
                    </span>
                    <span style="margin: 10px;margin-right: 10px;">
                        <input
                            :disabled="configLineItemMode"
                            type="checkbox"
                            id="chkRetrospectiveView"
                            v-model="retrospectiveView"
                            title="Adjust report to retroactively include any refunds or other adjustments made in the future"
                            aria-label="Adjust report to retroactively include any refunds or other adjustments made in the future"
                        />
                        <label for="chkRetrospectiveView" title="Adjust report to retroactively include any refunds or other adjustments" aria-label="Adjust report to retroactively include any refunds or other adjustments made in the future"
                            >Retrospective View</label
                        >
                    </span>
                </div>

                <table class="report-div-table" cellspacing="0">
                    <tr v-for="row in dataReport" :key="row.id" :class="'report-div-table-row ' + row.zebraIndex">
                        <td class="report-div-table-col" :style="'width:20%;' + (row.bold ? 'font-weight: bold;font-size:11pt' : '')" v-if="configLineItemMode || !row.hidden">
                            <span>
                                <label v-if="configLineItemMode">
                                    <input type="checkbox" v-model="row.hidden" />
                                </label>
                                {{ row.heading }}&nbsp;
                            </span>
                            <!-- {{ row.heading }}&nbsp; -->
                        </td>
                        <td class="report-div-table-col" style="width:40%;" v-if="configLineItemMode || !row.hidden">
                            <span>{{ row.measure }}</span>
                        </td>
                        <td :class="'report-div-table-col' + (row.credit ? ' credit-value' : '')" :style="'width:40%;text-align:right;' + (row.bold ? 'font-weight: bold;font-size:11pt' : '')" v-if="configLineItemMode || !row.hidden">
                            {{ row.value }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import RangeSelector from "@/views/components/Reports/RangeSelector.vue";
import apiReport from "@/api/apiReport";
import { storage } from "@/common/storage";
import { ref } from "@vue/reactivity";
import { getCurrentInstance, watch } from "@vue/runtime-core";
import Utilities from "@/common/utilities";
import { jsPDF } from "jspdf";
import Helper from "@/common/helper";
import PortalUserModel from "@/common/models/PortalUserModel";

export default {
    components: {
        RangeSelector
    },
    setup(props, { emit }) {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(true);

        const reportTitle = ref("Summary Report");
        const reportfilename = ref("SummaryReport");

        const dataReport = ref(null);
        const retrospectiveView = ref(true);

        var showTeeBox = false;
        var configLineItemMode = ref(false);
        var hiddenLineItemMode = [];

        var portalUser = PortalUserModel.fromToken();

        watch(retrospectiveView, () => {
            setData(data);
        });

        const setData = () => {
            data.retrospectiveView = retrospectiveView.value;

            dataReport.value = [
                // Income from POS - Item
                {
                    //heading: "Sales from POS" + ((portalUser.enablePos) ? " - By item" : ""),
                    id: "4c328bcc-b87a-41e6-9a82-7d97b31d4d48",
                    heading: "Portal Summary",
                    measure: "",
                    value: Utilities.toCurrency(data.manualEntry + data.pinCode + data.rangeCardReloads + data.salesItems + data.doorTurnstile + data.tBox + data.cashierRefunds + data.giftCreditPurchased),
                    raw: data.manualEntry + data.pinCode + data.rangeCardReloads + data.salesItems + data.doorTurnstile + data.tBox + data.cashierRefunds + data.giftCreditPurchased,
                    bold: true,
                    credit: false,
                    hidden: false
                },
                {
                    id: "9a358042-ce50-48e2-8628-0cc891d3395e",
                    heading: "",
                    measure: "Pin Codes",
                    value: Utilities.toCurrency(data.pinCode),
                    raw: data.pinCode,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "e2a99e94-e41d-4622-b6cd-b84137a66f7a",
                    heading: "",
                    measure: "Member Balance Reloads",
                    value: Utilities.toCurrency(data.rangeCardReloads),
                    raw: data.rangeCardReloads,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "c1024d9c-3146-415a-878d-7395c85633a0",
                    heading: "",
                    measure: "Member Balance Reloads - Open",
                    value: Utilities.toCurrency(data.manualEntry),
                    raw: data.manualEntry,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "65962951-ede5-4c63-bdc9-293226c1b874",
                    heading: "",
                    measure: "Sales Items",
                    value: Utilities.toCurrency(data.salesItems),
                    raw: data.salesItems,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "f5f2b3d2-9908-47b7-b5d8-edbb9b25d5a0",
                    heading: "",
                    measure: "Door/Turnstiles",
                    value: Utilities.toCurrency(data.doorTurnstile),
                    raw: data.doorTurnstile,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "10b79feb-a6f1-44a1-b5cb-3f972ec02e16",
                    heading: "",
                    measure: "Gift Cards",
                    value: Utilities.toCurrency(data.giftCreditPurchased),
                    raw: data.giftCreditPurchased,
                    bold: false,
                    credit: false,
                    hidden: false
                }
            ];

            if (showTeeBox) {
                dataReport.value.push(
                    // Income from POS - By payment
                    {
                        id: "2ee941b2-f7c3-405b-a216-61dc5bdd4926",
                        heading: "",
                        measure: "Tee-Boxes",
                        value: Utilities.toCurrency(data.tBox),
                        raw: data.tBox,
                        bold: false,
                        credit: false,
                        hidden: false
                    }
                );
            }

            if (portalUser.enablePos) {
                dataReport.value.push(
                    // Income from POS - By payment
                    {
                        id: "b5849739-7351-4b33-b3ed-b82f49c29800",
                        heading: "Income from POS",
                        measure: "",
                        value: Utilities.toCurrency(data.incomeFromPosCash + data.incomeFromPosCreditCardDisplay + data.refundIncomeFromPos),                        
                        raw: data.incomeFromPosCashDisplay + data.incomeFromPosCreditCardDisplay + data.refundIncomeFromPos,
                        bold: true,
                        credit: false,
                        hidden: false
                    },
                    {
                        id: "e75023ed-68c8-4a11-9bd1-f6c369d2b878",
                        heading: "",
                        measure: "Cash",
                        value: Utilities.toCurrency(data.incomeFromPosCashDisplay),
                        raw: data.incomeFromPosCashDisplay,
                        bold: false,
                        credit: false,
                        hidden: false
                    },
                    {
                        id: "b7d51f43-2183-401c-9251-a3f9a76fb1e1",
                        heading: "",
                        measure: "Credit Card",
                        value: Utilities.toCurrency(data.incomeFromPosCreditCardDisplay),
                        raw: data.incomeFromPosCreditCardDisplay,
                        bold: false,
                        credit: false,
                        hidden: false
                    },
                    {
                        id: "d8517d1c-1206-4467-8db2-a7b9118d81dd",
                        heading: "",
                        measure: "Total Refunds",
                        value: Utilities.toCurrency(data.refundIncomeFromPos),
                        raw: data.refundIncomeFromPos,
                        bold: false,
                        credit: false,
                        hidden: false
                    }
                );
            }

            dataReport.value.push(
                // Spacer
                {
                    id: "1a9dfdc6-54fe-4d15-9e4f-d69be1f13ccf",
                    heading: "",
                    measure: "",
                    raw: undefined,
                    bold: false,
                    credit: false,
                    hidden: false
                }
            );

            dataReport.value.push(
                // Income from Dispenser
                {
                    id: "98504f43-83a1-42b9-aee6-feae22daf528",
                    heading: "Income from Dispenser",
                    measure: "",
                    value: Utilities.toCurrency(data.bucketPurchaseCash + data.bucketPurchaseCreditCardsDisplay + data.bucketPurchaseRangeCardReloadsDisplay + data.refundIncomeFromDispenser),
                    raw: data.bucketPurchaseCash + data.bucketPurchaseCreditCardsDisplay + data.bucketPurchaseRangeCardReloadsDisplay + data.refundIncomeFromDispenser,
                    bold: true,
                    credit: false,
                    hidden: false
                },

                {
                    id: "83143190-017d-4ec3-ad02-98af45dd4c4e",
                    heading: "",
                    measure: "Member Balance Reloads",
                    value: Utilities.toCurrency(data.bucketPurchaseRangeCardReloadsDisplay),
                    raw: data.bucketPurchaseRangeCardReloadsDisplay,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "7633082d-113f-4f71-94d8-c42e04e8f316",
                    heading: "",
                    measure: "Bucket Purchase - Credit Card",
                    value: Utilities.toCurrency(data.bucketPurchaseCreditCardsDisplay),
                    raw: data.bucketPurchaseCreditCardsDisplay,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "b251c54d-3960-403c-b596-10ce4a251671",
                    heading: "",
                    measure: "Bucket Purchase - Cash",
                    value: Utilities.toCurrency(data.bucketPurchaseCash),
                    raw: data.bucketPurchaseCash,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "85fe906e-6f51-4660-b283-913d1e97b5e8",
                    heading: "",
                    measure: "Total Refunds",
                    value: Utilities.toCurrency(data.refundIncomeFromDispenser),
                    raw: data.refundIncomeFromDispenser,
                    bold: false,
                    credit: false,
                    hidden: false
                },

                // Income from Mobile App
                // Spacer
                {
                    id: "73d67b01-784a-448b-9d8d-203c7c011a2d",
                    heading: "",
                    measure: "",
                    raw: undefined,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "d0198df7-94ff-439a-abf5-210a79448db9",
                    heading: "Income from Mobile App",
                    measure: "",
                    value: Utilities.toCurrency(data.incomeFromMobileReloadsDisplay + data.incomeFromMobileTBoxDisplay + data.incomeFromMobilePincodeDisplay + data.refundIncomeFromVendor),
                    raw: data.incomeFromMobileReloadsDisplay + data.incomeFromMobileTBoxDisplay + data.incomeFromMobilePincodeDisplay + data.refundIncomeFromVendor,                    
                    bold: true,
                    credit: false,
                    hidden: false
                },
                {
                    id: "b4ebf0d7-26fb-47f2-92e6-e6063f7ae41c",
                    heading: "",
                    measure: "Member Balance Reloads",
                    value: Utilities.toCurrency(data.incomeFromMobileReloadsDisplay),
                    raw: data.incomeFromMobileReloadsDisplay,
                    bold: false,
                    credit: false,
                    hidden: false
                },

                {
                    id: "61950151-4b03-4fef-8995-b04c31d54f71",
                    heading: "",
                    measure: "Total Refunds",
                    value: Utilities.toCurrency(data.refundIncomeFromVendor),
                    raw: data.refundIncomeFromVendor,
                    bold: false,
                    credit: false,
                    hidden: false
                },

                // Income from Web Sales
                // Spacer
                {
                    id: "5802f7f9-69d3-4434-8e67-85a573063bec",
                    heading: "",
                    measure: "",
                    raw: undefined,
                    bold: false,
                    credit: false,
                    hidden: false
                },                
                {
                    id: "cc6d5867-8591-4e22-b341-ab9dbf7ed09d",
                    heading: "Income from Web Sales",
                    measure: "",
                    value: Utilities.toCurrency(data.incomeFromWebSalesPincodeDisplay + data.refundIncomeFromWebSales),
                    raw: data.incomeFromWebSalesPincodeDisplay + data.refundIncomeFromWebSales,
                    bold: true,
                    credit: false,
                    hidden: false
                },
                {
                    id: "d69d1cb4-9694-47bd-89d9-7ab12e6f716e",
                    heading: "",
                    measure: "Pin Codes",
                    value: Utilities.toCurrency(data.incomeFromWebSalesPincodeDisplay),
                    raw: data.incomeFromWebSalesPincodeDisplay,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "951c950e-2ab3-4088-8ae7-f21b8530e875",
                    heading: "",
                    measure: "Total Refunds",
                    value: Utilities.toCurrency(data.refundIncomeFromWebSales),
                    raw: data.refundIncomeFromWebSales,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                
                // TODO:sub - Undo
                // Income from Subscriptions
                // Spacer
                // {
                //     id: "26e60c50-261c-4920-905f-ae3d1526aed6",
                //     heading: "",
                //     measure: "",
                //     raw: undefined,
                //     bold: false,
                //     credit: false,
                //     hidden: false
                // },                
                // {
                //     id: "f8a47ca3-f051-41da-b59c-b3fa45ba4eac",
                //     heading: "Income from Subscriptions",
                //     measure: "",
                //     value: Utilities.toCurrency(data.incomeFromSubscriptionEnrollments + data.incomeFromSubscriptionRenewals),
                //     raw: data.incomeFromSubscriptions,
                //     bold: true,
                //     credit: false,
                //     hidden: false
                // },
                // {
                //     id: "63134232-ac5e-4312-95fb-81d418d0ea6a",
                //     heading: "",
                //     measure: "Enrollments",
                //     value: Utilities.toCurrency(data.incomeFromSubscriptionEnrollments),
                //     raw: data.incomeFromSubscriptionEnrollments,
                //     bold: false,
                //     credit: false,
                //     hidden: false
                // },
                // {
                //     id: "9cb01303-6d01-4d1a-8947-29ea6b162ad1",
                //     heading: "",
                //     measure: "Renewals",
                //     value: Utilities.toCurrency(data.incomeFromSubscriptionRenewals),
                //     raw: data.incomeFromSubscriptionRenewals,
                //     bold: false,
                //     credit: false,
                //     hidden: false
                // },                
            );

            // Custom line items
            data.customRecords.forEach((x) => dataReport.value.push(x));

            dataReport.value.push(
                // Range Card
                {
                    id: "9de8f1f4-6c97-4735-9e0e-66becea6f054",
                    heading: "",
                    measure: "",
                    raw: undefined,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "a65648da-2b6e-4597-9b09-73604e698f4b",
                    heading: "Range Card",
                    measure: "",
                    raw: undefined,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "927d2744-5bfd-4125-8d6a-c24b16562868",
                    heading: "",
                    measure: "Credits Purchased",
                    value: Utilities.toCurrency(data.creditPurchased),
                    raw: data.creditPurchased,
                    bold: false,
                    credit: true,
                    hidden: false
                },
                {
                    id: "a0221e85-eba1-4746-b85e-4a529a2fd5cf",
                    heading: "",
                    measure: "Credits Used",
                    value: Utilities.toCurrency(data.creditUsed),
                    raw: data.creditUsed,
                    bold: false,
                    credit: true,
                    hidden: false
                },
                {
                    id: "205d5de8-ffb9-446e-b6b1-88abb154bd7b",
                    heading: "",
                    measure: "Current Total Balance",
                    value: Utilities.toCurrency(data.currentTotalBalance),
                    raw: data.currentTotalBalance,
                    bold: false,
                    credit: true,
                    hidden: false
                },
                {
                    id: "af560051-9ec4-4f93-b4f8-442d9a01db20",
                    heading: "",
                    measure: "Current Total Customers with Balance",
                    value: Utilities.toNumeric(data.currentTotalCustomersWithBalance),
                    raw: data.currentTotalCustomersWithBalance,
                    bold: false,
                    credit: false,
                    hidden: false
                },

                // Gift Card
                {
                    id: "c6480136-4a0c-4976-8723-4df55b9d21e1",
                    heading: "",
                    measure: "",
                    raw: undefined,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "2c9b723f-0c69-4c92-987a-e832185a42e6",
                    heading: "Gift Card",
                    measure: "",
                    raw: undefined,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "c2a6bb7d-a1be-49ec-ace5-65335b272eaf",
                    heading: "",
                    measure: "Credits Purchased",
                    value: Utilities.toCurrency(data.giftCreditPurchased),
                    raw: data.giftCreditPurchased,
                    bold: false,
                    credit: true,
                    hidden: false
                },
                {
                    id: "7129ea50-062e-4482-bb9a-f7795ae7b9c7",
                    heading: "",
                    measure: "Credits Used",
                    value: Utilities.toCurrency(data.giftCreditUsed),
                    raw: data.giftCreditUsed,
                    bold: false,
                    credit: true,
                    hidden: false
                },

                // Other
                {
                    id: "4182cfd3-2bce-4883-afdd-0ab232d36621",
                    heading: "",
                    measure: "",
                    raw: undefined,
                    bold: false,
                    credit: false,
                    hidden: false
                },

                {
                    id: "6d8cd454-697e-4966-a645-36d38eadf9c4",
                    heading: "Total Income",
                    measure: "",
                    value: Utilities.toCurrency(totalIncome),
                    raw: totalIncome,
                    bold: false,
                    credit: false,
                    hidden: false
                },

                {
                    id: "65248ac2-022b-4148-bd50-2a8538d5f95c",
                    heading: "Combined Total (Portal Summary + Incomes)",
                    measure: "",                    
                    value: Utilities.toCurrency(totalIncome + data.manualEntry + data.pinCode + data.rangeCardReloads + data.salesItems + data.doorTurnstile + data.tBox + data.cashierRefunds + data.giftCreditPurchased),
                    raw: totalIncome + data.manualEntry + data.pinCode + data.rangeCardReloads + data.salesItems + data.doorTurnstile + data.tBox + data.cashierRefunds + data.giftCreditPurchased,
                    bold: false,
                    credit: false,
                    hidden: false
                },



                {
                    id: "dd799192-c495-422d-9b90-580225888f11",
                    heading: "",
                    measure: "",
                    raw: undefined,
                    bold: false,
                    credit: false,
                    hidden: false
                },

                {
                    id: "2b11d9f1-97fd-40c0-a823-3dfd4f2cea07",
                    heading: "Total Balls Dispensed",
                    measure: "",
                    value: Utilities.toNumeric(data.totalBallsDispensed),
                    raw: data.totalBallsDispensed,
                    bold: false,
                    credit: false,
                    hidden: false
                },

                {
                    id: "9a1cd972-81e1-4857-b433-535c026d4e3d",
                    heading: "Total Minutes Used",
                    measure: "",
                    value: Utilities.toNumeric(data.totalMinutesUsed),
                    raw: data.totalMinutesUsed,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "c4bd8272-498d-437e-b550-6f01020094d1",
                    heading: "Outstanding Pin Codes",
                    measure: "",
                    value: data.outstandingPinCode,
                    raw: data.outstandingPinCode,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "d6872364-543f-4f9f-a094-f7d660e17288",
                    heading: "Outstanding Door Pin Codes",
                    measure: "",
                    value: data.outstandingDoorPinCode,
                    raw: data.outstandingDoorPinCode,
                    bold: false,
                    credit: false,
                    hidden: false
                },
                {
                    id: "da7ee9f8-7a95-4a39-ad81-16cccf052cc2",
                    heading: "Total Customers With Subscriptions",
                    measure: "",
                    value: data.currentTotalCustomersWithSubscriptions,
                    raw: data.currentTotalCustomersWithSubscriptions,
                    bold: false,
                    credit: false,
                    hidden: false
                }
            );

            // Apply hidden setting
            dataReport.value.forEach((item) => {
                item.hidden = hiddenLineItemMode.filter((x) => x == item.id).length > 0;
            });

            // If Retrospective View then don't show Total Refunds            
            if (retrospectiveView.value) {
                dataReport.value = dataReport.value.filter((x) => x.measure != "Total Refunds");            
            }

            reapplyZebraStripes()
        };

        const onClose = () => {
            dataReport.value = null;
            emit("on-close");
        };

        var data;
        const onView = async () => {
            try {
                fetchingData.value = true;
                emitter.emit("server-call-start", "Loading...");

                var dataX = await apiReport.summary(storage.getReportDateStart(), storage.getReportDateEnd(), 0, false);
                var hiddenItems = await apiReport.getReportSettings(reportfilename.value);
                hiddenLineItemMode = hiddenItems == null ? [] : JSON.parse(hiddenItems);
                data = dataX[0];
                calculateTotalIncome(data);
                setData(data[0]);
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };

        var totalIncome = 0;
        const calculateTotalIncome = (data) => {
            console.log(data);
            if (portalUser.enablePos) {
                totalIncome =
                    // Income from Pos
                    data.incomeFromPosCash +
                    data.incomeFromPosCreditCard +
                    data.refundIncomeFromPos + 
                    // Income from Dispenser
                    data.bucketPurchaseCash +
                    data.bucketPurchaseCreditCards +
                    data.bucketPurchaseRangeCardReloads +
                    data.bucketPurchaseCreditCardsRefund +
                    data.bucketPurchaseRangeCardReloadsRefund +
                    // Income from Mobile App
                    data.incomeFromMobileReloads +
                    data.incomeFromMobileReloadsRefund
                    // TODO:sub - Implement
                    // Income from Subscriptions
                    // +data.incomeFromSubscriptions;
            } else {
                // TODO
                totalIncome =
                    // Income from Dispenser
                    data.bucketPurchaseCash +
                    data.bucketPurchaseCreditCards +
                    data.bucketPurchaseRangeCardReloads +
                    data.bucketPurchaseCreditCardsRefund +
                    data.bucketPurchaseRangeCardReloadsRefund +
                    // Income from Mobile App
                    data.incomeFromMobileReloads +
                    data.incomeFromMobileReloadsRefund
                    // TODO:sub - Implement
                    // Income from Subscriptions
                    //+ data.incomeFromSubscriptions;
            }
        };

        const reapplyZebraStripes = () => {
            // Apply hidden setting
            var indexCounter = 0
            dataReport.value.forEach((item) => {
                if (!item.hidden || configLineItemMode.value) {
                    item.zebraIndex = (indexCounter % 2 === 0 ? "odd" : "even");
                    indexCounter++
                }
            });
        }

        const exportCsv = () => {
            var csvData = [];
            dataReport.value.forEach((item) => {
                if (!item.hidden) {
                    var row = {
                        Section: item.heading.toExcelSafe(),
                        Measure: item.measure.toExcelSafe(),
                        Value: item.raw
                    };
                    csvData.push(row);
                }
            });
            Helper.exportCsv(csvData, reportfilename.value);
        };

        const savePdf = () => {
            const doc = new jsPDF();

            // Logo
            var img = new Image();
            img.src = "/images/icons/logo-sm.png";
            doc.addImage(img, "png", 10, 10, 60, 17);

            // Title
            doc.text(reportTitle.value, 10, 35);

            // Date Range
            doc.setFontSize(10);
            doc.text(
                `${storage
                    .getReportDateStart()
                    .toDateWithFormat("YYYY-MM-DD")
                    .toFullDateString()} To ${storage
                    .getReportDateEnd()
                    .toDateWithFormat("YYYY-MM-DD")
                    .toFullDateString()}`,
                200,
                35,
                "right"
            );

            // Header Separater
            doc.line(10, 40, 200, 40);

            // Generated Date Footer
            var page = 1;
            doc.setFontSize(8);
            doc.text("Generated " + new Date().toFullDateString() + "" + new Date().toLocaleTimeString(), 200, 290, "right");
            doc.text("Page " + page.toString(), 10, 290);

            // Body
            doc.setFontSize(10);
            var yPos = 50;
            var lineHeight = 7;

            var xSection = 12;
            var xField = 85;
            var xValue = 200;

            // Sales from POS - by item
            if (!hiddenLineItemMode.includes("4c328bcc-b87a-41e6-9a82-7d97b31d4d48")) {
                doc.setFontSize(11).setFont(undefined, "bold");
                doc.text("Portal Summary", xSection, yPos);
                doc.text(Utilities.toCurrency(data.manualEntry + data.pinCode + data.rangeCardReloads + data.salesItems + data.doorTurnstile + data.tBox + data.cashierRefunds + data.giftCreditPurchased), xValue, yPos, "right");
                doc.setFontSize(10).setFont(undefined, "normal");
            }

            if (!hiddenLineItemMode.includes("9a358042-ce50-48e2-8628-0cc891d3395e")) {
                yPos += lineHeight;
                doc.text("Pin Codes", xField, yPos);
                doc.text(Utilities.toCurrency(data.pinCode), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("e2a99e94-e41d-4622-b6cd-b84137a66f7a")) {
                yPos += lineHeight;
                doc.text("Member Balance Reloads", xField, yPos);
                doc.text(Utilities.toCurrency(data.rangeCardReloads), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("c1024d9c-3146-415a-878d-7395c85633a0")) {
                yPos += lineHeight;
                doc.text("Member Balance Reloads - Open", xField, yPos);
                doc.text(Utilities.toCurrency(data.manualEntry), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("65962951-ede5-4c63-bdc9-293226c1b874")) {
                yPos += lineHeight;
                doc.text("Sales Items", xField, yPos);
                doc.text(Utilities.toCurrency(data.salesItems), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("f5f2b3d2-9908-47b7-b5d8-edbb9b25d5a0")) {
                yPos += lineHeight;
                doc.text("Door/Turnstiles", xField, yPos);
                doc.text(Utilities.toCurrency(data.doorTurnstile), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("10b79feb-a6f1-44a1-b5cb-3f972ec02e16")) {
                yPos += lineHeight;
                doc.text("Gift Cards", xField, yPos);
                doc.text(Utilities.toCurrency(data.giftCreditPurchased), xValue, yPos, "right");
            }

            if (showTeeBox) {
                if (!hiddenLineItemMode.includes("2ee941b2-f7c3-405b-a216-61dc5bdd4926")) {
                    yPos += lineHeight;
                    doc.text("Tee-Boxes", xField, yPos);
                    doc.text(Utilities.toCurrency(data.tBox), xValue, yPos, "right");
                }
            }

            if (portalUser.enablePos) {
                // Income from POS - by payment
                if (!hiddenLineItemMode.includes("b5849739-7351-4b33-b3ed-b82f49c29800")) {                
                    yPos += lineHeight;
                    doc.setFontSize(11).setFont(undefined, "bold");
                    doc.text("Income from POS", xSection, yPos);
                    doc.text(Utilities.toCurrency(data.incomeFromPosCashDisplay + data.incomeFromPosCreditCardDisplay + data.refundIncomeFromPos), xValue, yPos, "right");
                    doc.setFontSize(10).setFont(undefined, "normal");
                }

                if (!hiddenLineItemMode.includes("e75023ed-68c8-4a11-9bd1-f6c369d2b878")) {
                    yPos += lineHeight;
                    doc.text("Cash", xField, yPos);
                    doc.text(Utilities.toCurrency(data.incomeFromPosCashDisplay), xValue, yPos, "right");
                }

                if (!hiddenLineItemMode.includes("b7d51f43-2183-401c-9251-a3f9a76fb1e1")) {
                    yPos += lineHeight;
                    doc.text("Credit Card", xField, yPos);
                    doc.text(Utilities.toCurrency(data.incomeFromPosCreditCardDisplay), xValue, yPos, "right");
                }

                if (!retrospectiveView.value) {
                    if (!hiddenLineItemMode.includes("d8517d1c-1206-4467-8db2-a7b9118d81dd")) {
                        yPos += lineHeight;
                        doc.text("Total Refunds", xField, yPos);
                        doc.text(Utilities.toCurrency(data.refundIncomeFromPos), xValue, yPos, "right");
                    }
                }
            }

            // Income from Dispenser
            if (!hiddenLineItemMode.includes("98504f43-83a1-42b9-aee6-feae22daf528")) {
                yPos += lineHeight;
                doc.setFontSize(11).setFont(undefined, "bold");
                doc.text("Income from Dispenser", xSection, yPos);
                doc.text(Utilities.toCurrency(data.bucketPurchaseCash + data.bucketPurchaseCreditCardsDisplay + data.bucketPurchaseRangeCardReloadsDisplay + data.refundIncomeFromDispenser), xValue, yPos, "right");
                doc.setFontSize(10).setFont(undefined, "normal");
            }

            if (!hiddenLineItemMode.includes("83143190-017d-4ec3-ad02-98af45dd4c4e")) {
                yPos += lineHeight;
                doc.text("Member Balance Reloads", xField, yPos);
                doc.text(Utilities.toCurrency(data.bucketPurchaseRangeCardReloadsDisplay), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("7633082d-113f-4f71-94d8-c42e04e8f316")) {
                yPos += lineHeight;
                doc.text("Bucket Purchase - Credit Card", xField, yPos);
                doc.text(Utilities.toCurrency(data.bucketPurchaseCreditCardsDisplay), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("b251c54d-3960-403c-b596-10ce4a251671")) {
                yPos += lineHeight;
                doc.text("Bucket Purchase - Cash", xField, yPos);
                doc.text(Utilities.toCurrency(data.bucketPurchaseCash), xValue, yPos, "right");
            }

            if (!retrospectiveView.value) {
                if (!hiddenLineItemMode.includes("85fe906e-6f51-4660-b283-913d1e97b5e8")) {
                    yPos += lineHeight;
                    doc.text("Total Refunds", xField, yPos);
                    doc.text(Utilities.toCurrency(data.refundIncomeFromDispenser), xValue, yPos, "right");
                }
            }

            // Income from Mobile App
            if (!hiddenLineItemMode.includes("d0198df7-94ff-439a-abf5-210a79448db4")) {
                yPos += lineHeight;
                doc.setFontSize(11).setFont(undefined, "bold");
                doc.text("Income from Mobile App", xSection, yPos);
                doc.text(Utilities.toCurrency(data.incomeFromMobileReloadsDisplay + data.incomeFromMobileTBoxDisplay + data.incomeFromMobilePincodeDisplay + data.refundIncomeFromVendor), xValue, yPos, "right");
                doc.setFontSize(10).setFont(undefined, "normal");
            }

            if (!hiddenLineItemMode.includes("b4ebf0d7-26fb-47f2-92e6-e6063f7ae41c")) {
                yPos += lineHeight;
                doc.text("Member Balance Reloads", xField, yPos);
                doc.text(Utilities.toCurrency(data.incomeFromMobileReloadsDisplay), xValue, yPos, "right");
            }

            if (!retrospectiveView.value) {
                if (!hiddenLineItemMode.includes("61950151-4b03-4fef-8995-b04c31d54f71")) {
                    yPos += lineHeight;
                    doc.text("Total Refunds", xField, yPos);
                    doc.text(Utilities.toCurrency(data.refundIncomeFromVendor), xValue, yPos, "right");
                }
            }
                        
            // Income from Web Sales
            if (!hiddenLineItemMode.includes("cc6d5867-8591-4e22-b341-ab9dbf7ed09d")) {
                yPos += lineHeight;
                doc.setFontSize(11).setFont(undefined, "bold");
                doc.text("Income from Web Sales", xSection, yPos);
                doc.text(Utilities.toCurrency(data.incomeFromWebSalesPincodeDisplay + data.refundIncomeFromWebSales), xValue, yPos, "right");
                doc.setFontSize(10).setFont(undefined, "normal");
            }

            if (!hiddenLineItemMode.includes("d69d1cb4-9694-47bd-89d9-7ab12e6f716e")) {
                yPos += lineHeight;
                doc.text("Pin Codes", xField, yPos);
                doc.text(Utilities.toCurrency(data.incomeFromWebSalesPincodeDisplay), xValue, yPos, "right");
            }
            
            if (!retrospectiveView.value) {
                if (!hiddenLineItemMode.includes("951c950e-2ab3-4088-8ae7-f21b8530e875")) {
                    yPos += lineHeight;
                    doc.text("Total Refunds", xField, yPos);
                    doc.text(Utilities.toCurrency(data.refundIncomeFromWebSales), xValue, yPos, "right");
                }
            }
            

            // TODO:sub - Undo
            // Income from Subscriptions
            // if (!hiddenLineItemMode.includes("f8a47ca3-f051-41da-b59c-b3fa45ba4eac")) {
            //     yPos += lineHeight;
            //     doc.setFontSize(11).setFont(undefined, "bold");
            //     doc.text("Income from Subscriptions", xSection, yPos);
            //     doc.text(Utilities.toCurrency(data.incomeFromSubscriptionEnrollments + data.incomeFromSubscriptionRenewals), xValue, yPos, "right");
            //     doc.setFontSize(10).setFont(undefined, "normal");
            // }

            // if (!hiddenLineItemMode.includes("63134232-ac5e-4312-95fb-81d418d0ea6a")) {
            //     yPos += lineHeight;
            //     doc.text("Enrollments", xField, yPos);
            //     doc.text(Utilities.toCurrency(data.incomeFromSubscriptionEnrollments), xValue, yPos, "right");
            // }

            // if (!hiddenLineItemMode.includes("9cb01303-6d01-4d1a-8947-29ea6b162ad1")) {
            //     yPos += lineHeight;
            //     doc.text("Renewals", xField, yPos);
            //     doc.text(Utilities.toCurrency(data.incomeFromSubscriptionRenewals), xValue, yPos, "right");
            // }

            // Range Card
            if (!hiddenLineItemMode.includes("a65648da-2b6e-4597-9b09-73604e698f4b")) {
                yPos += lineHeight + lineHeight;
                doc.text("Range Card", xSection, yPos);
            }

            yPos += lineHeight;
            if (!hiddenLineItemMode.includes("927d2744-5bfd-4125-8d6a-c24b16562868")) {
                doc.text("Credits Purchased", xField, yPos);
                doc.text(Utilities.toCurrency(data.creditPurchased), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("a0221e85-eba1-4746-b85e-4a529a2fd5cf")) {
                yPos += lineHeight;
                doc.text("Credits Used", xField, yPos);
                doc.text(Utilities.toCurrency(data.creditUsed), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("205d5de8-ffb9-446e-b6b1-88abb154bd7b")) {
                yPos += lineHeight;
                doc.text("Current Total Balance", xField, yPos);
                doc.text(Utilities.toCurrency(data.currentTotalBalance), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("af560051-9ec4-4f93-b4f8-442d9a01db20")) {
                yPos += lineHeight;
                doc.text("Current Total Customers with Balance", xField, yPos);
                doc.text(Utilities.toNumeric(data.currentTotalCustomersWithBalance), xValue, yPos, "right");
            }

            // Gift Card
            if (!hiddenLineItemMode.includes("2c9b723f-0c69-4c92-987a-e832185a42e6")) {
                yPos += lineHeight + lineHeight;
                doc.text("Gift Card", xSection, yPos);
            }

            if (!hiddenLineItemMode.includes("c2a6bb7d-a1be-49ec-ace5-65335b272eaf")) {
                yPos += lineHeight;
                doc.text("Credits Purchased", xField, yPos);
                doc.text(Utilities.toCurrency(data.giftCreditPurchased), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("7129ea50-062e-4482-bb9a-f7795ae7b9c7")) {
                yPos += lineHeight;
                doc.text("Credits Used", xField, yPos);
                doc.text(Utilities.toCurrency(data.giftCreditUsed), xValue, yPos, "right");
            }

            // Others
            if (!hiddenLineItemMode.includes("6d8cd454-697e-4966-a645-36d38eadf9c4")) {
                yPos += lineHeight;
                doc.text("Total Income", xSection, yPos);
                doc.text(Utilities.toCurrency(totalIncome), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("65248ac2-022b-4148-bd50-2a8538d5f95c")) {
                yPos += lineHeight;
                doc.text("Combined Total (Portal Summary + Incomes)", xSection, yPos);
                doc.text(Utilities.toCurrency(totalIncome + data.manualEntry + data.pinCode + data.rangeCardReloads + data.salesItems + data.doorTurnstile + data.tBox + data.cashierRefunds + data.giftCreditPurchased), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("2b11d9f1-97fd-40c0-a823-3dfd4f2cea07")) {
                yPos += lineHeight;
                doc.text("Total Balls Dispensed", xSection, yPos);
                doc.text(Utilities.toNumeric(data.totalBallsDispensed), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("9a1cd972-81e1-4857-b433-535c026d4e3d")) {
                yPos += lineHeight;
                doc.text("Total Minutes Used", xSection, yPos);
                doc.text(Utilities.toNumeric(data.totalMinutesUsed), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("c4bd8272-498d-437e-b550-6f01020094d1")) {
                yPos += lineHeight;
                doc.text("Outstanding Pin Codes", xSection, yPos);
                doc.text(data.outstandingPinCode.toString(), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("d6872364-543f-4f9f-a094-f7d660e17288")) {
                yPos += lineHeight;
                doc.text("Outstanding Door Pin Codes", xSection, yPos);
                doc.text(data.outstandingDoorPinCode.toString(), xValue, yPos, "right");
            }

            if (!hiddenLineItemMode.includes("da7ee9f8-7a95-4a39-ad81-16cccf052cc2")) {
                yPos += lineHeight;
                doc.text("Total Customers With Subscriptions", xSection, yPos);
                doc.text(data.currentTotalCustomersWithSubscriptions.toString(), xValue, yPos, "right");
            }

            doc.save(reportfilename.value + ".pdf");
        };

        const toggleLineItemConfig = async () => {
            configLineItemMode.value = !configLineItemMode.value;
            reapplyZebraStripes()
            if (!configLineItemMode.value) {
                hiddenLineItemMode = dataReport.value.filter((x) => x.hidden).map((x) => x.id);
                await apiReport.saveReportSettings(reportfilename.value, JSON.stringify(hiddenLineItemMode));
            }
        };

        return {
            reportTitle,
            dataReport,
            onClose,
            onView,

            savePdf,
            exportCsv,

            portalUser,
            retrospectiveView,
            configLineItemMode,
            toggleLineItemConfig
        };
    }
};
</script>

<style scoped>
.report-modal {
    width: 90%;
    height: 70%;
    margin: 100px auto;
    background: white;
}

tr.odd {
    background: white;
}
tr.even {
    background: rgb(221, 220, 220);
}

tr:nth-child(even) {
    /* background-color: rgb(221, 220, 220); */
}

tr:nth-child(odd) {
    /* background-color: white; */
}
</style>
